import { render, staticRenderFns } from "./Biolink.vue?vue&type=template&id=0c5fdd00"
import script from "./Biolink.vue?vue&type=script&lang=js"
export * from "./Biolink.vue?vue&type=script&lang=js"
import style0 from "./Biolink.vue?vue&type=style&index=0&id=0c5fdd00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports